import React, { Component } from 'react'
import {
  Button, Icon, Form
} from 'antd'

import { connect } from 'react-redux'
import { TableComp, FormUtils } from 'sz-react-utils-lite'
import { allGeneralSubscriptionFxn } from '../action'
import AddGeneralSubscriptionDrawer from '../drawer/add'
import { DisplayDate } from '../../../components/_utils/appUtils'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'


const keyObj = {
  'oneYear': 'One Year',
  'threeYear': 'Three Year',
  'lifeTime': 'Life Time',
  'online': 'Online',
  'print': 'Print',
  'printOnline': 'Print Online'
}
const regExpFilters = ['journalName', 'nationality']

@Form.create()
class GeneralSubscription extends Component {
  state = {
    editSubscription: false,
    journalList: [],
    nationalityArr: [{ value: 'Indian', display: 'Indian', _id: 'Indian' }, {
      value: 'Foreign',
      display: 'Foreign',
      _id: 'Foreign'
    }],
    yearArr: [],
    yearList: [],
    subscriptionList: [],
    visible: false,
    open: false,
    subscriptionDat: {},
    sendData: {}
  }

  events = {
    showDrawer: data => {
      this.setState({
        visible: true
      })
    },
    hideDrawer: () => {
      this.setState({
        visible: false
      })
      this.table.current.reload()
    }
  }


  setYears = () => {
    let yearArr = []
    let i = 2019
    while (i < 2026) {
      yearArr.push({ value: i, display: i, _id: i })
      i++
    }
    this.setState({ yearList: yearArr })
  }


  reload = () => {
    this.table.current.reload()
  }

  openSubsciption = (subscriptionId) => {

    this.setState({ editSubscription: true, subscriptionId: subscriptionId })

  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
    this.state = {
      visible: false
    }
  }

  closeEditSubscription = () => {
    this.setState({ editSubscription: false })
    this.reload()
  }
  subscriptionSubmit = (reminObj) => {
    this.setState({ remindObj: reminObj })
    this.closeEditSubscription()
  }

  componentDidMount() {

  }

  apiRequest = (params) => {
    let { dispatch, form: { getFieldValue } } = this.props
    return new Promise(async (resolve) => {
      let obj = {
        sortField: 'createdAt',
        sortOrder: 'descend',
        ...params

      }
      let data = await dispatch(allGeneralSubscriptionFxn({ ...obj, regExFilters: regExpFilters }))
      resolve(data)
    })
  }


  render() {

    const { dispatch } = this.props

    const columns = [
      {
        title: 'Sr No.',
        dataIndex: 'orderNo',
        //align: 'center',
        key: 'index',
        width: 50,
        render: (text, record, index) => {
          return <div className={'alignCenter'}>{index + 1}</div>
        }
      },
      {
        key: 'name',
        title: 'Name',
        dataIndex: 'name'
      },
      {
        key: 'email',
        title: 'Email',
        dataIndex: 'email',
        sorter: true
      },
      {
        key: 'mobile',
        title: 'Mobile',
        dataIndex: 'mobile'
      },
      {
        key: 'address',
        title: 'Address',
        dataIndex: 'address'
      },

      {
        title: 'Date',
        dataIndex: 'createdAt',

        key: 'createdAt',
        sorter: true,

        render: (text, record, index) => {
          return <div className={'alignCenter'}>{DisplayDate(record.createdAt)}</div>
        }
      },
      {
        key: 'pincode',
        title: 'Pincode',
        dataIndex: 'pincode'
      },
      {
        title: 'city',
        key: 'City',
        dataIndex: 'city'
      },
      {
        title: 'state',
        key: 'State',
        dataIndex: 'state'
      },
      {
        title: 'country',
        key: 'Country',
        dataIndex: 'country'
      },
      {
        title: 'Subscribe By',
        key: 'subscribeBy',
        dataIndex: 'subscribeBy'
      },

      {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        render: (text) => {
          if (!text || text.length === 0) return ''

          const displayText = text.charAt(0).toUpperCase() + text.slice(1)
          const statusClass = text.toLowerCase()

          return <span className={`status-badge ${statusClass}`}>{displayText}</span>
        }
      },
      {
        key: 'actions',
        title: 'Actions',
        width: 150,
        render: (val, record) => (
          <React.Fragment>
            {/*<Tooltip title='Edit Details'>*/}
            <a className={'roundSmallBtn'} href={`/singleGeneralSubscription/${record._id}`}>
              View Details
            </a>
            {/*</Tooltip>*/}
            <br />
            {/*<a className={'roundSmallBtn'} href={`/article/edit/${record._id}`}>*/}
            {/*  Edit*/}
            {/*</a>*/}


          </React.Fragment>
        )
      }

    ]


    const formItemLayout = {
      labelCol: {
        xs: { span: 2 },
        sm: { span: 3 },
        md: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 22 },
        sm: { span: 22 },
        md: { span: 22 }
      }
    }

    // console.log(...this.state.journalList)

    return (
      <PageHeaderWrapper
        title={'Journal Subscription'}
        content={[
          <Button size='small' type='primary'
            onClick={() => this.events.showDrawer()}>
            <Icon type={'plus'} /> Add Subscription
          </Button>
        ]}
      >

        <TableComp columns={columns}
          extraProps={{ scroll: { x: 1200 } }}
          ref={this.table} apiRequest={this.apiRequest} />


        {this.state.visible ? (
          <AddGeneralSubscriptionDrawer
            visible={this.state.visible}
            onClose={() => this.events.hideDrawer()}
          />
        ) : null}


      </PageHeaderWrapper>)

  }
}


const mapStateToProps = ({ global }) => ({
  categories: global.categories
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GeneralSubscription)
